import React, { FC, memo } from "../../../lib/teact/teact";
import { tienFormat } from "../utils/NumberUtils";
import './ItemDataCanChuyen.scss'

type OwnProps = {
    data: any;
    curItem: any;
}

const ItemDataCanChuyenGroupTotal: FC<OwnProps> = ({
    data, curItem,
}) => {
    const { dataCanChuyenStruct, mapTotal } = data;
    const item = curItem;
    const key = `${item.daiId1}.${item.daiId2}:${item.loaiCuocId}`;
    const diemTotal = mapTotal.get(key) || 0;
    return <div className=" total-item">
        Tổng thừa {key} {tienFormat(diemTotal, 1)}
    </div>
}

export default memo(ItemDataCanChuyenGroupTotal);